





















































import HeadService from '~/services/HeadService'
import Breadcrumbs from '~/components/car/Breadcrumbs.vue'
import {
  computed,
  defineComponent,
  useStore,
  onUnmounted
} from '@nuxtjs/composition-api'
import Facets from '~/components/shared/quick-search/facets/Facets.vue'
import { CategoryId } from '~/models/category/types'
import {
  QUICK_SEARCH_NS,
  QuickSearchState
} from '~/store/modules/shared/quickSearch/state'
import Categories from '~/components/shared/quick-search/Categories.vue'
import RecentSearchesSelect from '~/components/shared/quick-search/RecentSearchesSelect.vue'
import TopContainer from '~/components/shared/quick-search/TopContainer.vue'
import { Config } from '~/models/quick-search/types'
import { preconnectLink } from '~/factories/head'
import { SET_CONFIG } from '~/store/modules/shared/quickSearch/mutation-types'
import CFeeds from '~/components/shared/configurable/CFeeds.vue'
import { useQuickSearchPage } from '~/compositions/quick-search/useQuickSearchPage'
import ShowOnMapButton from '~/components/car/classifieds/search/results/ShowOnMapButton.vue'
import { useNamespacedStore } from '~/compositions/store'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import AppPrompt from '~/components/plot/landing/AppPrompt.vue'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import { ciTimes } from '~/icons/source/regular/times'
import { SET_SEARCH_TYPE } from '~/store/modules/shared/classifieds/search/mutation-types'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'

export default defineComponent({
  components: {
    TopContainer,
    Breadcrumbs,
    RecentSearchesSelect,
    Facets,
    Categories,
    CFeeds,
    ShowOnMapButton,
    AppPrompt
  },
  middleware({ redirect, store }) {
    const isPc = store.getters[`${USER_AGENT_NS}/isPc`]
    if (isPc) {
      redirect('/quick-search/plot')
    }
  },
  async asyncData({ store, $s, app: { i18n } }: any) {
    const config: Config = {
      baseUrl: '/api/plot/quick-search/',
      title: i18n.t('search classifieds::plot_landing_page'),
      rootCategoryId: CategoryId.PLOT,
      facetsCols: {
        offertype: 3,
        category: 2,
        location: 4
      },
      backgroundImagesUrls: [
        $s('/nuxt-static/img/quick-search/aggelies-akinhtwn-mobile.png')
      ],
      logo: 'https://static.car.gr/static/images/plot/plot-logo.svg?v=2'
    }
    await store.commit(`${QUICK_SEARCH_NS}/${SET_CONFIG}`, config)
    await Promise.all([
      store.dispatch(`${QUICK_SEARCH_NS}/loadData`),
      store.dispatch(`${QUICK_SEARCH_NS}/loadCategoriesData`)
    ])
  },
  setup() {
    const { breadcrumbs } = useQuickSearchPage()
    const { state } = useNamespacedStore<QuickSearchState>(QUICK_SEARCH_NS)
    const { commit } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)

    const store = useStore()
    const isPc = computed(() => store.getters[`${USER_AGENT_NS}/isPc`])

    const searchMapTargetUrl = computed(() => state.targets.searchMap?.seoUrl)

    const icons = {
      externalLink: ciExternalLink,
      close: ciTimes
    }

    onUnmounted(() => commit(SET_SEARCH_TYPE, false))

    return { icons, breadcrumbs, searchMapTargetUrl, isPc }
  },
  head() {
    const headService = this.$requestContainer.resolve(HeadService)

    return headService.createHead({
      title: `Plot - ${this.$i18n.t('search')}`,
      link: [preconnectLink('https://www.plot.gr/')]
    })
  }
})
